// src/utils/formatName.js
import { isGibberish } from './isGibberish';
import { remove as removeDiacritics } from 'diacritics';

export function formatName(rawInput = '', {
  locale = 'en',
  offensiveWords = [],
  fallbackName = 'Amigo',
} = {}) {
  const preserveDiacriticsLanguages = ['es', 'fr', 'pt', 'pl', 'hu', 'vi'];
  const safeInput = preserveDiacriticsLanguages.includes(locale)
    ? rawInput
    : removeDiacritics(rawInput);

  const cleaned = safeInput.replace(/[^a-zA-ZÀ-ÿ\u00f1\u00d1\s]/g, '');
  const normalized = cleaned.replace(/\s+/g, ' ').trim();

  const isInvalid = (
    !normalized ||
    normalized.length < 2 ||
    offensiveWords.includes(normalized.toLowerCase()) ||
    isGibberish(normalized, locale)
  );

  const finalName = isInvalid
    ? fallbackName
    : normalized
        .split(' ')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');

  return finalName;
}